export const navigationData = [
    {
        id: "DashBoard",
        header: "DashBoard",
        icon: "lni lni-grid-alt",
        link: "/user/home",
    },
    {
        id: "adminmanagementID",
        header: "Admin",
        icon: "lni lni-user",
        Childs: [
            { id: "functionalitiesID", Name: "Functionalities", link: "/user/functions" },
            { id: "branchesID", Name: "Branchs", link: "/user/branchs" },
            { id: "departmentsID", Name: "Departments", link: "/user/deps" },
            { id: "jobpositionsID", Name: "JobPositions", link: "/user/positions" },
            { id: "shiftsID", Name: "Shifts", link: "/user/shifts" },
        ],
    },
    {
        id: "employeemanagementID",
        header: "Employee",
        icon: "lni lni-users",
        Childs: [
            { id: "employeelistID", Name: "Total Employees", link: "/user/emp" },
            { id: "employeeaddID", Name: "Add Employee", link: "/user/addemp" },
            { id: "salaryslipsID", Name: "Salary Slips", link: "/user/salaryslip" },
            { id: "coursesID", Name: "Courses", link: "/user/courses" },
            { id: "subjectsID", Name: "Subjects", link: "/user/subcourses" },
        ],
    },
    {
        id: "leavemanagementID",
        header: "Leaves",
        icon: "lni lni-protection",
        Childs: [
            { id: "todayleavesID", Name: "Today Leaves", link: "/user/todayLeaves" },
            { id: "leaverequestsID", Name: "Leave Requests", link: "/user/leaveRequest" },
            { id: "leavereportID", Name: "Leave Report", link: "/user/leaveReport" },
            { id: "myleavesID", Name: "My Leaves", link: "/user/selfLeave" },
            { id: "companyleavesID", Name: "Company Leaves", link: "/user/leaveShow" },
            { id: "balanceleavesID", Name: "Balance Leaves", link: "/user/blncleaves" },
        ],
    },
    {
        id: "rolesmanagementID",
        header: "Roles",
        icon: "lni lni-layout",
        Childs: [
            { id: "totalrolesID", Name: "Total Roles", link: "/user/userdetails" },
        ],
    },
    {
        id: "attendencemanagementID",
        header: "Attendance",
        icon: "bi bi-calendar2-week",
        Childs: [
            { id: "allattendanceID", Name: "All Attendance", link: "/user/attendence" },
            { id: "employeeattendancereportID", Name: "Attendance Report", link: "/user/attreport" },
            { id: "attendanceregularizationID", Name: "Regularization", link: "/user/regular" },
            { id: "earlyandlateID", Name: "Early & Late", link: "/user/earlyLate" },
            { id: "myattendanceID", Name: "My Attendance", link: "/user/myattendence" },
            { id: "workinghoursID", Name: "Working Hours", link: "/user/workinghours" },
            { id: "todayworkinghoursID", Name: "Today Working Hours", link: "/user/todayworkinghoures" },
        ],
    },
    {
        id: "vacationcampID",
        header: "VacationCamp",
        icon: "bi bi-book",
        Childs: [
            { id: "liststudentsID", Name: "List Students", link: "/user/listing" },
            { id: "addstudentsID", Name: "Add Students", link: "/user/addstd" },
            { id: "batchesID", Name: "Batches", link: "/user/batches" },
            { id: "studentattendancereportID", Name: "Attendance Report", link: "/user/streport" },
            { id: "feereportID", Name: "Fee Report", link: "/user/feereport" },
        ],
    },
    {
        id: "DashBoard",
        header: "Policy",
        icon: "lni lni-book",
        link: "/user/policy",
    },
    {
        id: "DashBoard",
        header: 'Hierarchy',
        icon: 'bi bi-diagram-3',
        link: '/user/hierarchy',
    }
];
